<div class="body">
  <mat-toolbar class="toolbar">
    <div class="menu d-print-none">
      <button mat-icon-button class="noOutline" (click)="toggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <div class="full-width">
      <div class="row full-width">
        <div class="col-sm-12 d-print-none d-flex">
          <span class="toolbar-title">{{ moduleTitle }}</span>
        </div>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container
    class="sidenav-container mat-sidenav-collapse-transition"
    autosize
  >
    <mat-sidenav
      [ngClass]="{ 'mat-sidenav-collapsed': !isExpanded && !isShowing }"
      #sidenav
      opened="true"
      class="d-print-none"
      mode="side"
      (mouseenter)="mouseenter()"
      (mouseleave)="mouseleave()"
    >
      <!-- Section 1 -->
      <mat-nav-list>
        <mat-list-item>
          <mat-icon
            matListItemIcon
            *ngIf="!isExpanded && !isShowing"
            class="blue"
            >search</mat-icon
          >
          <filter-box
            (changed)="changedFilter($event)"
            *ngIf="isExpanded || isShowing"
          ></filter-box>
        </mat-list-item>
      </mat-nav-list>

      <mat-nav-list id="left-nav-buttons">
        <mat-list-item
          (click)="AddEditDialog()"
          class="parent"
          *ngIf="hasPrivilege(privilege.BlRequiringApprovalAdd)"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Create New</span
          >
          <mat-icon matListItemIcon class="yellow">add_box</mat-icon>
        </mat-list-item>
      </mat-nav-list>

      <mat-nav-list style="height: 1px; overflow: hidden">
        <mat-list-item class="parent">
          <span
            class="full-width"
            *ngIf="isExpanded || isShowing"
            style="width: 100px"
          >
          </span>
        </mat-list-item>
      </mat-nav-list>

      <!-- <mat-nav-list class="pb-3">
        <hr />
        <mat-list-item (click)="settings()" class="parent" *ngIf="isSA()">
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Settings</span
          >
          <mat-icon mat-list-icon class="gray">settings</mat-icon>
        </mat-list-item>
      </mat-nav-list> -->
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="sidenav-content container-fluid">
        <span class="font-weight-bold fz-8">*Uses Optical Element</span>
        <div #bratoiTable id="bratoiTable" class="mat-container">
          <mat-table matSort [dataSource]="dataSource">
            <ng-container matColumnDef="resource">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                >Beamline/PSS</mat-header-cell
              >
              <mat-cell
                [ngClass]="{ blInactive: !element.isActive }"
                *matCellDef="let element"
              >
                <span
                  [innerHTML]="
                    element.resourceString | highlightSearch : filter
                  "
                ></span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="documentation">
              <mat-header-cell *matHeaderCellDef>Documentation</mat-header-cell>
              <mat-cell
                [ngClass]="{ blInactive: !element.isActive }"
                *matCellDef="let element"
                class="d-flex flex-column align-items-start"
              >
                <div *ngFor="let link of element.links">
                  <div class="my-1" *ngIf="link?.webAddress">
                    <span
                      [innerHTML]="
                        link.linkType.name | highlightSearch : filter
                      "
                    ></span
                    >:
                    <a href="{{ link.webAddress }}" target="_blank">
                      <span
                        [innerHTML]="link.hyperlink | highlightSearch : filter"
                      ></span>
                    </a>
                  </div>
                  <div class="my-1" *ngIf="!link?.webAddress">
                    <span
                      [innerHTML]="
                        link.linkType.name | highlightSearch : filter
                      "
                    ></span
                    >:
                    <a
                      ><span
                        [innerHTML]="link.hyperlink | highlightSearch : filter"
                      ></span>
                    </a>
                  </div>
                </div>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="criticalApertures">
              <mat-header-cell *matHeaderCellDef>
                List Of Critical Apertures
              </mat-header-cell>
              <mat-cell
                [ngClass]="{ blInactive: !element.isActive }"
                *matCellDef="let element"
                class="d-flex flex-column align-items-start"
              >
                <div *ngFor="let toca of element.tocas">
                  <div class="my-1">
                    <span
                      [innerHTML]="toca.name | highlightSearch : filter"
                    ></span>

                    <span class="shared ml-2"
                      ><span
                        [innerHTML]="
                          getTocaSharedWith(element, toca) ?? ''
                            | highlightSearch : filter
                        "
                      ></span>
                    </span>
                  </div>
                </div>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="approval">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                BRC Approval
              </mat-header-cell>
              <mat-cell
                [ngClass]="{ blInactive: !element.isActive }"
                *matCellDef="let element"
              >
                <div
                  *ngIf="
                    element?.action != 1 &&
                    hasPrivilege(privilege.BlRequiringApprovalApprove)
                  "
                >
                  <div *ngIf="element.isActive">
                    <button
                      class="approveBtn"
                      mat-flat-button
                      color="primary"
                      [disabled]="disableAction"
                      (click)="updateAction(element, action.Approve)"
                    >
                      Approve
                    </button>
                  </div>
                </div>
                <div *ngIf="element?.action == action.Approve">
                  <div class="approve">
                    {{ element.actionBy.name }}
                    <br />
                    {{ element.actionOn | date : "longDate" }}
                  </div>
                </div>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="action">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                Action
              </mat-header-cell>
              <mat-cell
                [ngClass]="{ blInactive: !element.isActive }"
                *matCellDef="let element"
              >
                <div>
                  {{ action[element.action] }}
                </div>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="options">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                Options
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <div *ngIf="element.isActive && validateShowMenu(element)">
                  <div class="cellx pt-1">
                    <button
                      mat-icon-button
                      [matMenuTriggerFor]="menu"
                      aria-label="Schedules menu"
                    >
                      <mat-icon class="blue">more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                      <button
                        mat-menu-item
                        *ngIf="
                          element?.action != 1 &&
                          hasPrivilege(privilege.BlRequiringApprovalEdit)
                        "
                        (click)="AddEditDialog(element)"
                      >
                        <mat-icon class="yellow">edit</mat-icon>
                        <span>Edit</span>
                      </button>
                      <button
                        mat-menu-item
                        *ngIf="
                          element?.action != 1 &&
                          hasPrivilege(privilege.BlRequiringApprovalDelete)
                        "
                        (click)="confirmDeleteDialog(element)"
                      >
                        <mat-icon class="red">delete</mat-icon>
                        <span>Delete</span>
                      </button>
                      <button
                        mat-menu-item
                        *ngIf="
                          element?.action == 1 &&
                          hasPrivilege(privilege.BlRequiringApprovalUnapprove)
                        "
                        [disabled]="disableAction"
                        (click)="updateAction(element, action.Unapprove)"
                      >
                        <mat-icon class="red">close</mat-icon>
                        <span>Unapprove</span>
                      </button>
                      <button
                        mat-menu-item
                        *ngIf="element?.action >= 0"
                        (click)="showHistory(element)"
                      >
                        <mat-icon class="blue">history</mat-icon>
                        <span>History</span>
                      </button>
                    </mat-menu>
                  </div>
                </div>
              </mat-cell>
            </ng-container>

            <mat-header-row
              #header
              class="p-0"
              *matHeaderRowDef="displayedColumns; sticky: true"
            ></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          </mat-table>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <!-- "loading">
    <!-- Copyright 2017 Google Inc. All Rights Reserved.
      Use of this source code is governed by an MIT-style license that
      can be found in the LICENSE file at http://angular.io/license -->
  <!-- </overlay-loading> -->
</div>

<button
  mat-mini-fab
  class="returnBtn"
  color="primary"
  aria-label="Return"
  *ngIf="headerOnTop"
  (click)="scrollToTop(headerTop)"
>
  <mat-icon class="p-0">arrow_upward</mat-icon>
</button>
